//
// Copyright 2025 DXOS.org
//

import { OperationHandlerSet } from '@dxos/compute';

export const MapOperationHandlerSet = OperationHandlerSet.lazy(() => import('./toggle'));
